// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadImageButton_root__1M1nP","input":"UploadImageButton_input__3JrQx","text":"UploadImageButton_text__2PexC"};